export const APP_ID = 'web-registration-hello'
export const AMPLITUDE_CONTROL_EXPERIMENT = 'control'
export const AMPLITUDE_EXPERIMENT_VARIATION_1 = 'v1'
export const AMPLITUDE_EXPERIMENT_VARIATION_2 = 'v2'
export const AMPLITUDE_EXPERIMENT_VARIATION_3 = 'v3'
export const USER_UUID = 'USER_UUID'
export const START_INVESTMENT_STORAGE_KEY = 'START_INVESTMENT_USER_SELECTION'
export const VISITOR_ID_KEY = 'VISITOR_ID'
export const ACORNS_HELLO_FLOW = 'ACORNS_HELLO_FLOW'
export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/acorns-invest-spare-change/id883324671'
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.acorns.android'
export const IS_RESUME_FLOW = 'IS_RESUME_FLOW'
export const EMAIL_FROM_MARKETING_SITE = 'EMAIL_FROM_MARKETING_SITE'
export const VISITED_PAGES = 'VISITED_PAGES'
export const TIER_PRICE_ID = 'TIER_PRICE_ID'
export const TIER_PRICE = 'TIER_PRICE'
export const TIER_NAME = 'TIER_NAME'
export const TIER_KEY = 'TIER_KEY'
export const ACORNS_DISCLOSURES_URL = 'https://www.acorns.com/disclosures/'
export const USER_TYPE = 'USER_TYPE'
export const CURRENT_SIGN_UP_SCREEN_KEY = 'CURRENT_SIGN_UP_SCREEN'
export const APP_VERSION = process.env.RELEASE_TAG?.toString().trim() || ''
